module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-8-1d9d1a95e3b67180ef8744008cab5019.svg";